import { RsvpStatus } from '@wix/events-types';
export const getAvatars = (members = [], totalGuests, isRsvp, maxAvatars, isMembersVisibleInEditor) => {
    if (isMembersVisibleInEditor && !members.length && !totalGuests) {
        return [{}, {}];
    }
    const memberAvatars = getMemberAvatars(members, isRsvp);
    return [...memberAvatars, ...getAnonymousAvatars(totalGuests, maxAvatars, memberAvatars.length)];
};
const getMemberAvatars = (members = [], isRsvp) => {
    if (isRsvp) {
        members = members.filter(member => member.rsvpStatus === RsvpStatus.YES);
    }
    return members.map(member => ({
        name: member.nickname,
        src: member.imageUrl,
    }));
};
const getAnonymousAvatars = (totalGuests, maxAvatars, memberCount) => {
    const total = getTotalAttendingGuests(totalGuests);
    const neededAvatarCount = Math.min(maxAvatars, total);
    const anonymousAvatars = [];
    while (anonymousAvatars.length < neededAvatarCount - memberCount) {
        anonymousAvatars.push({});
    }
    return anonymousAvatars;
};
export const getExtraGuestsCount = (totalGuests, maxAvatars) => {
    const total = getTotalAttendingGuests(totalGuests) - maxAvatars;
    return total > 0 ? total : 0;
};
const getTotalAttendingGuests = (totalGuests) => typeof totalGuests === 'number' ? totalGuests : totalGuests.YES || 0;
export const hasGuestsGoing = (totalGuests, isRsvp) => { var _a; return isRsvp ? !!((_a = totalGuests === null || totalGuests === void 0 ? void 0 : totalGuests.YES) !== null && _a !== void 0 ? _a : 0) : !!totalGuests; };
//# sourceMappingURL=members.js.map